





















































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import JobWorkerInterviewDto from '@/models/JobWorkerInterviews/JobWorkerInterviewDto';
import { JobDetailsModule } from '@/store/modules/jobDetails';

import UpdateJobWorkerInterviewFeedbackRequest from '@/models/JobWorkerInterviews/UpdateJobWorkerInterviewFeedbackRequest';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';

@Component({
    name: 'JobWorkerInterviewFeedbackEdit'
})
export default class extends GiganautVueDialog {

    @Prop({required: true})
    jobWorkerInterview: JobWorkerInterviewDto;
    @Prop({required: true})
    jobWorkerStatus: JobWorkerStatus;
    workerFeedback = '';
    contactFeedback = '';

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.workerFeedback = this.jobWorkerInterview.workerFeedback;
            this.contactFeedback = this.jobWorkerInterview.contactFeedback;
        }
    }

    get loading() {
        return JobDetailsModule.loadingDialog;
    }

    get disabled() {
		if (this.jobWorkerStatus === JobWorkerStatus.InterviewOne || this.jobWorkerStatus === JobWorkerStatus.InterviewTwo) {
            return false;
        }
        return true;
	}

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        const request = new UpdateJobWorkerInterviewFeedbackRequest();
        request.jobWorkerInterviewId = this.jobWorkerInterview.id;
        request.updatedAt = this.jobWorkerInterview.updatedAt;
        request.workerFeedback = this.workerFeedback;
        request.contactFeedback = this.contactFeedback;
        await JobDetailsModule.editJobWorkerInterviewFeedback(request);
        this.dialog = false;
    }
}
